package system.network

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import component.*
import io.ktor.util.date.*
import models.*
import kotlin.jvm.*

class PhysicSnapshotStateSystem : IteratingSystem(family { all(PhysicSnapshotStateComponent, PhysicComponent) }) {

    @Volatile
    private var sequenceCounter = 0

    fun setSequence(serverStartTime: Long) {
        val currentTime = getTimeMillis()
        val diffMills = currentTime - serverStartTime
        val sequence = diffMills / 16
        sequenceCounter = sequence.toInt()
    }

    override fun onTick() {
        sequenceCounter++

        super.onTick()
    }

    override fun onTickEntity(entity: Entity) {
        val snapshotComp = entity[PhysicSnapshotStateComponent]
        val physicComponent = entity[PhysicComponent]
        val inputDataComponent = entity[NetworkInputDataComponent]

        snapshotComp.snapshots.enqueue(
            StateSnapshot(
                sequence = sequenceCounter,
                physicState = PhysicState(
                    id = inputDataComponent.id,
                    x = physicComponent.body.position.x,
                    y = physicComponent.body.position.y,
                    velocityX = physicComponent.body.linearVelocityX,
                    velocityY = physicComponent.body.linearVelocityY
                )
            )
        )
    }
}

data class StateSnapshot(
    val sequence: Int,
    val physicState: PhysicState
)
